var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThirdweb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 516 321",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3:35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.40497 27.0011C-3.73633 14.022 5.84519 0 19.8669 0H106.919C115.098 0 122.342 4.86715 125.381 12.3996L194.671 185.299C196.541 189.935 196.541 195.149 194.671 199.901L151.087 308.484C144.427 325.056 120.823 325.056 114.163 308.484L1.40497 27.0011Z",
    fill: "url(#paint0_linear_3:35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.547 26.4217C164.873 13.5585 174.454 0 188.242 0H264.077C272.49 0 279.968 5.2148 282.772 12.9791L345.753 185.879C347.272 190.166 347.272 194.918 345.753 199.321L307.894 303.27C301.585 320.652 276.813 320.652 270.503 303.27L169.547 26.4217Z",
    fill: "url(#paint1_linear_3:35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.331 27.0011C316.19 14.022 325.771 0 339.793 0H426.845C435.024 0 442.269 4.86715 445.307 12.3996L514.597 185.299C516.467 189.935 516.467 195.149 514.597 199.901L471.013 308.484C464.353 325.056 440.75 325.056 434.089 308.484L321.331 27.0011Z",
    fill: "url(#paint2_linear_3:35)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3:35",
    x1: 7.40492,
    y1: 55.24,
    x2: 260.485,
    y2: 164.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F213A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1517,
    stopColor: "#E011A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4554,
    stopColor: "#B20DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8789,
    stopColor: "#6806BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5204BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3:35",
    x1: 175.093,
    y1: 54.447,
    x2: 410.968,
    y2: 148.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F213A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1517,
    stopColor: "#E011A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4554,
    stopColor: "#B20DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8789,
    stopColor: "#6806BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5204BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3:35",
    x1: 327.331,
    y1: 55.24,
    x2: 580.411,
    y2: 164.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F213A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1517,
    stopColor: "#E011A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4554,
    stopColor: "#B20DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8789,
    stopColor: "#6806BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5204BF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3:35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 516,
    height: 321,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdweb);
export default __webpack_public_path__ + "static/media/thirdweb.134073119e5756932d06137b0368bac9.svg";
export { ForwardRef as ReactComponent };